'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { Suspense, useEffect, useRef } from 'react';
import { pushEcommerceEvent } from './data-layer';

function PageViewEventInner({ pageTitle }: { pageTitle?: string }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const trackedKeyRef = useRef<string | null>(null);

  useEffect(() => {
    const key = pathname + '?' + searchParams.toString() + (pageTitle || '');
    if (trackedKeyRef.current === key) return;
    trackedKeyRef.current = key;

    pushEcommerceEvent({
      event: 'page_view',
      ecommerce: {
        page_title: pageTitle || document.title,
        page_location: window.location.href,
        page_path: window.location.pathname,
      },
    });
  }, [pathname, searchParams, pageTitle]);

  return null;
}

export function PageViewEvent({ pageTitle }: { pageTitle?: string }) {
  return (
    <Suspense fallback={null}>
      <PageViewEventInner pageTitle={pageTitle} />
    </Suspense>
  );
}
